const STORAGE_KEY = 'resume_edit_secret';

export function getSavedSecret(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function saveSecret(secret: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, secret);
  } catch {
    // ignore: storage may be disabled or full
  }
}

export function clearSavedSecret(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
